var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3803 3.32555C14.1803 1.82555 11.4636 2.52555 9.99692 4.24221C8.53026 2.52555 5.81359 1.81721 3.61359 3.32555C2.44692 4.12555 1.71359 5.47555 1.66359 6.90055C1.54692 10.1339 4.41359 12.7255 8.78859 16.7005L8.87192 16.7755C9.50526 17.3505 10.4803 17.3505 11.1136 16.7672L11.2053 16.6839C15.5803 12.7172 18.4386 10.1255 18.3303 6.89221C18.2803 5.47555 17.5469 4.12555 16.3803 3.32555ZM10.0803 15.4589L9.99692 15.5422L9.91359 15.4589C5.94692 11.8672 3.33026 9.49221 3.33026 7.08388C3.33026 5.41721 4.58026 4.16721 6.24692 4.16721C7.53026 4.16721 8.78026 4.99221 9.22192 6.13388H10.7803C11.2136 4.99221 12.4636 4.16721 13.7469 4.16721C15.4136 4.16721 16.6636 5.41721 16.6636 7.08388C16.6636 9.49221 14.0469 11.8672 10.0803 15.4589Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/likeIcon.9eff8bd2090ba82f128c9fd3ecce9c32.svg";
export { ForwardRef as ReactComponent };